import { getOrCreateDeviceId } from '../lib/deviceId';
import { getJson, postJson, requestVoid } from './client';

// --- Types (identityservice UserDeviceController) ---

export type DevicePlatform = 'WEB' | 'ANDROID' | 'IOS';

export type DeviceRegistrationRequest = {
  deviceId: string;
  platform: DevicePlatform;
  fcmToken?: string;
  appVersion?: string;
  osVersion?: string;
  deviceModel?: string;
};

export type DeviceResponse = {
  deviceId: string;
  platform: DevicePlatform;
  appVersion: string | null;
  lastSeenAt: string;
  registeredAt: string;
  hasPushToken: boolean;
};

// --- Functions ---

export function registerDevice(req: DeviceRegistrationRequest) {
  return postJson<DeviceResponse>('/api/v1/users/me/devices', req);
}

export function getMyDevices() {
  return getJson<DeviceResponse[]>('/api/v1/users/me/devices');
}

export function removeDevice(deviceId: string) {
  return requestVoid(`/api/v1/users/me/devices/${encodeURIComponent(deviceId)}`, {
    method: 'DELETE',
  });
}

/** Web 디바이스 정보 조립 — 로그인 요청의 `device` 필드 및 직접 등록에 공용. */
export function buildWebDeviceInfo(): DeviceRegistrationRequest {
  return {
    deviceId: getOrCreateDeviceId(),
    platform: 'WEB',
    osVersion: typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 100) : undefined,
  };
}

/**
 * 로그인 직후 best-effort 디바이스 등록. 실패는 무시 — 세션과 무관한 부가 기능
 * (소셜 로그인 경로에는 login body 의 device 필드가 없어 이 경로만 존재).
 */
export async function registerCurrentDeviceBestEffort(): Promise<void> {
  try {
    await registerDevice(buildWebDeviceInfo());
  } catch {
    // best-effort: 디바이스 등록 실패가 로그인 흐름을 막으면 안 된다.
  }
}
